module.exports = __webpack_public_path__ + "media/images/companyPage/team_spirit-51ac938d06ff241c2158b854b7f84556.svg";